export default {
  update: {
    MUSIC_PLAYING_STATUS: 'UPDATE_MUSIC_PLAYING_STATUS',
    USER_DATA: 'UPDATE_USER_DATA',
    REPORT_STATUS: 'UPDATE_REPORT_STATUS',
    SHARED_CONTENTS: 'UPDATE_SHARED_CONTENTS'
  }
}



// WEBPACK FOOTER //
// ./src/store/mutation-types.js